import {IEnhancedStore} from '@montana/models/dev';

export const encodeReservedChars = (str: string | undefined): string | undefined => {
    if (!str) {
        return;
    }
    const reservedCharacters = [['!','%21'],['*','%2A'],['[(]','%28'], ['[)]','%29'], [';','%3B'], [':','%3A'], ['@','%40'], ['&','%26'], ['=','%3D'], ['$','%24'], [',','%2C'], ['/','%2F'], ['#','%23']];
    const regex = /[!*'();:@&=$,/#[\]]/g;
    let encodedString = str;
    if (encodedString.match(regex)) {
        reservedCharacters.forEach((arr) => {
            if (encodedString.indexOf(arr[0]) >= 0) {
                try {
                    encodedString = encodedString.replace(new RegExp(arr[0],'gi'), arr[1]);
                } catch (e) {
                    console.error('Encoding string failed with error:', e);
                }
            }
        });
    }
    return encodedString;
}
export const formatUrlToGoogleMaps = (store: IEnhancedStore): string => {
    const queryString = new URLSearchParams();
    queryString.append('api', '1');
    queryString.append('query', `${encodeReservedChars(store?.name)},${encodeReservedChars(store?.address)},${store?.zipCode},${encodeReservedChars(store?.city)},${store?.country},${store.websiteText}`);
    return `https://www.google.com/maps/search//?${queryString.toString()}`;
}
